module.exports = __webpack_public_path__ + "img/folder-bookmark.3cbe6bf9.svg";